import React from 'react'
import { Button, Col, Dropdown, Form, Row, Stack } from "react-bootstrap"
import { KTCard, KTCardBody, KTIcon } from "../../../../../../_metronic/helpers"
import Select from 'react-select'
import { Fragment, useContext, useEffect, useState } from "react";
import { getActualizarGroupField, getExternalById, getExternals, updateExternalData } from "../../../../../services/external";
import ReactJson from "react-json-view";
import { Api, initExternalData, PartnerContext } from "../../PartnerContexts";
import GroupFieldServicio from "./GroupFieldServicio";
import * as excelJs from 'exceljs';
import { useGlobalOverlayLoading } from '../../../../../shared/hooks/useGlobalOverlayLoading';
import { formatDateToDMY } from "../../../../../helpers/dateFunctions";
import { showMessage } from "../../../../../shared/Alerts";
import { TableBusiness } from "../../../../generales_component/table/TableBusiness";

interface MyProps {

}

type Columns = {NameGrupo: string; NameCampo: string,Value: string}[]

const UpdateServicio : React.FC<MyProps> = () => {
    const {reloadServiceExternal,setExternalData,setReloadServiceExternal,setShowCargarPlantillaExcel,setInfoData,setIsInfoModalOpen} = useContext(PartnerContext)
    const [listService, setListService] = useState<any[]>([]);
    const [idSelectService,setIdSelectService] = useState("")
    const [edit,setEdit] = useState(false)
    const [reloadExternalApi,setReloadExternalApi] = useState(false)
    const [nameApi, setNameApi] = useState("")
    const [urlApi, setUrlApi] = useState("")
    const [bodyApi, setBodyApi] = useState({ key: "value" });
    const [arrayApi, setArrayApi] = useState<Api[]>([]);
    const [loading, setLoading] = useState(false)
    const [dataServiceExternal,setDataServiceExternal] = useState(initExternalData)
    const {setGlobalOverlayLoading} = useGlobalOverlayLoading()

    useEffect(()=>{
        refetchData()
    },[])    
    
    useEffect(()=>{
        if(reloadServiceExternal){
            setReloadServiceExternal(false)
            refetchData()
        }
    },[reloadServiceExternal])

    useEffect(()=>{
        if(idSelectService) getExternalId(idSelectService)
    },[idSelectService])

    useEffect(() => {
        if(reloadExternalApi){
            setReloadExternalApi(false)
            reloadDataExternalApi()
        }
    },[reloadExternalApi])

    const reloadDataExternalApi = async () => {
        setLoading(true)
        await getActualizarGroupField(idSelectService)
        .then((response)=>{
            setLoading(false)
            if (response.success) {
                showMessage("success","Actualizado",response.message)
                setDataServiceExternal(initExternalData)
                setReloadServiceExternal(true)
            } else {
                showMessage("error","Hubo un problema",response.message)
                setDataServiceExternal(initExternalData)
                setReloadServiceExternal(true)
                console.log(response.msg)
            }
        })
    }

    const refetchData = async () => {
        await getExternals({typedata:"NAME_SERVICES"})
        .then((response)=>{
            if (response.success) {
                setListService(response.data.map((x: any) => ({ label: x.service, value: x._id })))
                if(idSelectService) getExternalId(idSelectService)
            } else {
                console.log(response.msg)
            }
        })
    }

    
    const handleChangeService = (e: any) => {
        setIdSelectService(e.value)
    }

    const getExternalId = async (id:string) =>{
        await getExternalById(id)
        .then((response) => {
            setDataServiceExternal(response.data)
            setExternalData(response.data)
            if(response.data.api && response.data.api.length > 0){
                setArrayApi(response.data.api)
            }
            setEdit(false)           
        })
        .catch((error) => console.log(error))
    }

    const handleChange = (e: any) => {
        setDataServiceExternal({...dataServiceExternal, [e.target.name]: e.target.value})
    }

    const handleExport = () => {
        const columns : Columns = []
        columns.push({NameGrupo:"Servicio - Grupo 1 ",NameCampo:"label",Value:"Razón Social"})
        columns.push({NameGrupo:"Servicio - Grupo 1 ",NameCampo:"identifier",Value:"CL_RazonSocial"})
        columns.push({NameGrupo:"Servicio - Grupo 1 ",NameCampo:"type",Value:"string"})
        exportExcelJS(columns)
    }

    const exportExcelJS = async (columns: Columns) => {
        const workbook = new excelJs.Workbook()
        const worksheet = workbook.addWorksheet()

        worksheet.mergeCells(`A1:${getExcelLetter(columns.length)}1`);
        const groupCell = worksheet.getCell('A1');
        groupCell.value = columns[0].NameGrupo;
        groupCell.font = {
            name: 'Calibri',
            size: 14,
            bold: true,
            color: { argb: 'FFFFFF' },
        };
        groupCell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '0A58CA' },
            bgColor: { argb: '' },
        };
        groupCell.alignment = { vertical: 'middle', horizontal: 'center' };
        /* let Ini = 1
        let fin = 0
        Object.keys(objectSeccion).map((key,ind) => {
            fin = fin + objectSeccion[key]
            worksheet.mergeCells(`${getExcelLetter(Ini)}2:${getExcelLetter(fin)}2`)
            
            const groupCell = worksheet.getCell(`${getExcelLetter(Ini)}2`);
            groupCell.value = key;
            groupCell.font = {
            name: 'Calibri',
            size: 13,
            bold: true,
            color: { argb: 'FFFFFF' },
            };
            groupCell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: getRandomColorRGB() },
            bgColor: { argb: '' },
            };
            
            groupCell.alignment = { vertical: 'middle', horizontal: 'center' };  
            
            Ini = Ini + objectSeccion[key]      
        }) */

        // Adding Header Row
        const header = columns.map((el) => el.NameCampo);
        const headerKeys = columns.map((el) => ({ key: el.NameCampo }));
        const value = columns.map((el) => el.Value);
        const headerRow = worksheet.addRow(header);
        const contentRow = worksheet.addRow(value);
        worksheet.columns = headerKeys;
        headerRow.eachCell((cell) => {
        cell.alignment = {
            horizontal: 'center',
        };
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'DCE0F7' },
            bgColor: { argb: '' },
        };
        cell.font = {
            color: { argb: '45494E' },
            size: 12,
        };
        });
        
        contentRow.eachCell((cell) => {
        cell.alignment = {
            horizontal: 'center',
        };
        cell.font = {
            color: { argb: '45494E' },
            size: 12,
        };
        if(cell.value === "date"){
            cell.value = formatDateToDMY(new Date());
            cell.numFmt = 'dd/mm/yyyy';
        }
        });
        
        
        if (worksheet.columns) {
        worksheet.columns.forEach(function (column) {
            if (column) {
            let dataMax = 0;
            column.eachCell && column.eachCell({ includeEmpty: true }, function (cell, idx) {
                const columnLength = cell.value ? String(cell.value).length : 0;
                if (columnLength > dataMax) {
                dataMax = columnLength;
                }
            });
            if (column) {
                column.width = dataMax < 15 ? 15 : dataMax;
            }
            }
        });
        }

        worksheet.addRows([{}, {}, {}]);
        
        const rowToLock = worksheet.getRow(5);
        rowToLock.eachCell((cell) => {
        cell.protection = {
            locked: true,
        };
        });




        workbook.xlsx.writeBuffer()
        .then((buffer) => {
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'mi_archivo_excel.xlsx';
        a.click();
        })
        .finally(() => setGlobalOverlayLoading(false))
    
    }

    const getExcelLetter = (number:number) => {
        let result = '';
        while (number > 0) {
            const remainder = (number - 1) % 26;
            result = String.fromCharCode(65 + remainder) + result;
            number = Math.floor((number - 1) / 26);
        }
        return result;
    };
    
    const handleUpdateExternal = (updatedData:any) => {
        setDataServiceExternal({...dataServiceExternal,fields:updatedData})
    };
    
    const handleSubmit = (e: any) => {
        e.preventDefault()
        if (dataServiceExternal._id !== "") {
            setLoading(true)
            updateExternalData(dataServiceExternal._id,dataServiceExternal)
            .then((response) => {
                if (response.success) {  
                showMessage("success","Actualizado",response.message)
                setDataServiceExternal(initExternalData)
                setReloadServiceExternal(true)
                setLoading(false)
                } else {
                setLoading(false)
                console.log(response)
                }
            })
            .catch((error) => {
                setLoading(false)
                console.log(error)
            })
        }
    }

    const handleShowDetalle = (show:boolean,userData: any) => {
        setInfoData(userData)
        setIsInfoModalOpen(show)
    }

    const addApi = () => {
        setArrayApi([...arrayApi,{name:nameApi,url:urlApi,body:bodyApi}])
    }

    const handleEdit = (edit:any) => {
        if (edit.updated_src) {
            setBodyApi(edit.updated_src);
        }
    };

    return (
        <>
            <div className="card card-custom ">
                <div className="card-header d-flex align-items-center"  >
                    <Stack direction='vertical' gap={1}>
                        <span className='fw-bold'>Seleccione Servicio:</span>
                        <Select
                            styles={{
                                control: (provided) => ({
                                ...provided,
                                fontSize: '13px',
                                minHeight: '42px', // Reducción del alto
                                height: '42px',
                                }),
                            }}
                            placeholder='Seleccione el servicio'
                            options={listService}
                            onChange={handleChangeService}
                        />
                    </Stack> 
                    {
                        idSelectService && (
                            <a
                                href='#'
                                className='btn btn-icon btn-bg-light btn-light-primary btn-sm mx-3'
                                title='Editar'
                                onClick={() => setEdit(true)}
                                >
                                <KTIcon iconName='pencil' className='fs-3' />
                            </a>
                        )
                    }                   
                    
                    {/* <a
                        href='#'
                        className='btn btn-icon btn-bg-light btn-light-danger btn-sm mx-3'
                        title='Eliminar'
                        // onClick={() => handleActualizar(item)}
                        >
                        <KTIcon iconName='cross' className='fs-3' />
                    </a> */}
                </div>
                <div className="card-body card-scroll h-620px">
                    { !edit ? (
                        <Row className='mb-3'>
                            <label className="my-2"><b>Servicio : </b>{dataServiceExternal.service}</label>

                            
                            {dataServiceExternal.api && dataServiceExternal.api.length > 0 && (
                                <>
                                <label className="my-2"><b>Lista de APIS </b> 
                                    <a
                                        href='#'
                                        className={`btn  btn-bg-light btn-light-primary btn-sm mx-3`}
                                        title='Actualizar Los Campos de los APIS'
                                        onClick={() => setReloadExternalApi(true)}
                                        >
                                        {!loading && ( <>Actualizar <KTIcon iconName='loading' className='fs-3' /></>)}
                                            {loading && (
                                                <span className='indicator-progress' style={{display: 'block'}}>
                                                Actualizando...{' '}
                                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                                </span>
                                        )}                                            
                                    </a>
                                </label>
                                {dataServiceExternal.api.map((ap, i) => (
                                    <>
                                    {i == 0 && <div className="separator my-1"></div>} 
                                        <label ><b>Nombre: </b>{ap.name} 
                                            <label ><b>URL: </b>{ap.url} 
                                                <a
                                                    href='#up'
                                                    className='btn btn-icon btn-bg-light btn-light-primary btn-sm mx-2'
                                                    title='Ver Detalle'
                                                    onClick={() => handleShowDetalle(true, ap.body)}
                                                >
                                                    <KTIcon iconName='eye' className='fs-3' />
                                                </a>
                                            </label> 
                                        </label>                                        
                                        <div className="separator my-1"></div>
                                    </>
                                    
                                ))}
                                </>
                                
                                
                            )}
                            
                            <ReactJson src={dataServiceExternal.fields} />
                        </Row>
                    ):(
                        <Row className='mb-3'>
                            <Form onSubmit={handleSubmit}>
                                <div className="card card-custom">
                                    <div className="card-body card-scroll h-450px">                    
                                        <Form.Group controlId='formService'>
                                            <Form.Label>Ingrese Nombre Perfil</Form.Label>
                                            <Form.Control
                                            type='text'
                                            className='form-control-sm'                      
                                            required
                                            value={dataServiceExternal.service}
                                            placeholder='Ingrese un codigo'
                                            onChange={handleChange}  
                                            name='service'
                                            />
                                        </Form.Group>   
                                        
                                        <Form.Group controlId='formApi' className="mt-3">
                                            <Form.Label>Ingrese Detalle Api (Opcional)</Form.Label>
                                            <Stack direction='horizontal' gap={1}>
                                            <Form.Control
                                                type='text'
                                                className='form-control-sm'                      
                                                required
                                                value={nameApi}
                                                placeholder='Ingrese Nombre de API'
                                                onChange={(e)=>{setNameApi(e.target.value)}}  
                                                name='api'
                                                />
                                            </Stack>
                                            
                                            <Form.Control
                                                type='text'
                                                className='form-control-sm mt-2'                      
                                                required
                                                value={urlApi}
                                                placeholder='Ingrese URL del API'
                                                onChange={(e)=>{setUrlApi(e.target.value)}} 
                                                name='api'
                                                />

                                            <ReactJson
                                                style={{marginTop:"10px"}}
                                                src={bodyApi}
                                                onEdit={handleEdit}
                                                onAdd={handleEdit}
                                                onDelete={handleEdit}
                                                theme="monokai"
                                                />
                                            
                                            <a
                                                href='#'
                                                className='btn   btn-primary btn-sm mt-2'
                                                title='Añadir Api'
                                                onClick={() => addApi()}
                                                >
                                                    Añadir a la tabla
                                                <KTIcon iconName='plus' className='fs-3 mx-3' />
                                            </a>
                                        </Form.Group>
                                        <div className='table-responsive mt-5'>
                                            <TableBusiness
                                                checkbox={{
                                                include: false
                                                }}
                                                headers={[
                                                {key: 'nombre', value: 'Nombre'},
                                                {key: 'url', value: 'Url'},
                                                {key: 'actions', value: 'Acciones'},
                                                ]}
                                            >
                                                {arrayApi.length > 0 ? (
                                                arrayApi?.map((item: any) => (
                                                    <Fragment key={item.name}>
                                                    <tr>
                                                        <td className='text-start min-w-100px p-0'><span className="mx-1">{item.name}</span></td>
                                                        <td className='text-start min-w-100px p-0'><span className="mx-1">{item.url}</span></td>
                                                        <td className='text-end d-flex align-self-end justify-content-end p-0'>
                                                        <Stack direction='horizontal' gap={1}>
                                                            <a
                                                                href='#up'
                                                                className='btn btn-icon btn-bg-light btn-light-primary btn-sm mx-2'
                                                                title='Ver Detalle'
                                                                onClick={() => handleShowDetalle(true, item.body)}
                                                            >
                                                                <KTIcon iconName='eye' className='fs-3' />
                                                            </a>
                                                            <a
                                                                href='#up'
                                                                className='btn btn-icon btn-bg-light btn-light-danger btn-sm mx-2'
                                                                title='Eliminar'
                                                                // onClick={() => handleShowDetalle(true, item.info)}
                                                            >
                                                                <KTIcon iconName='cross' className='fs-3' />
                                                            </a>
                                                        </Stack>
                                                        </td>
                                                    </tr>
                                                    </Fragment>
                                                ))
                                                ) : (
                                                <tr>
                                                    <td colSpan={5}>
                                                    <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                                                        No matching records found
                                                    </div>
                                                    </td>
                                                </tr>
                                                )}
                                            </TableBusiness>
                                        </div>               
                                        <Form.Group controlId='formFieldExcel' className="mt-3">   
                                            <Stack direction='horizontal' gap={2}>
                                                <Dropdown>
                                                    
                                                <Dropdown.Toggle variant='primary' id='dropdown-basic'>
                                                    <KTIcon iconName='file-down' className='fs-2' />
                                                    Carga Masiva Nuevo Grupo de Campos
                                                </Dropdown.Toggle>
                                                
                                                <Dropdown.Menu>
                                                    <Dropdown.Item href='#' onClick={handleExport} >
                                                    Exportar Plantilla
                                                    </Dropdown.Item>
                                                    <Dropdown.Item href='#' onClick={() => {setShowCargarPlantillaExcel(true)} }>
                                                    Cargar Plantilla
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                                </Dropdown>
                                            </Stack>                                      
                                        </Form.Group>               
                                        <Form.Group controlId='formField' className="mt-3">
                                            <GroupFieldServicio key={"idGroupFieldServicio"} onUpdate={(updatedData) => handleUpdateExternal(updatedData)} field={dataServiceExternal.fields} />
                                        </Form.Group>
                                    </div>
                                    <div className="card-footer">
                                        <div className='d-flex justify-content-end'>
                                            <Button variant='danger' type='button' onClick={()=>{setEdit(false)}}>
                                                {'Cancelar'}
                                            </Button>
                                            <Button variant='success' className="mx-2" type='submit'>
                                                {!loading && edit && 'Actualizar'}
                                                {loading && (
                                                    <span className='indicator-progress' style={{display: 'block'}}>
                                                    Subiendo...{' '}
                                                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                                    </span>
                                                )}
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </Form>
                        </Row>
                    )}    
                </div>
                <div className="card-footer">
                    
                </div>
            </div>
        </>
    )
}
export default UpdateServicio